var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBlackCurveArrow = function SvgBlackCurveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.495 14.2c-43.871-5.722-82.383 10.908-107.111 48-12.661 18.991 13.789 48.938 26.311 26.4 11.677-21.017-25.218-47.544-40.8-51.644-33.808-8.898-66.476-6.756-100.8-6.756M19.295 20.6C15.63 22.973-4.208 31.544 5.784 35.178c5.092 1.852 10.014 5.638 15.11 7.822M244.895 3c2.011 1.085 19.946 7.812 20.711 10.489.699 2.446-3.323 2.742-4.711 3.911-3.751 3.158-6.769 3.753-9.6 8",
    stroke: "#1C1C1C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
};

export default SvgBlackCurveArrow;